import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MaterialModule } from '../modules/material.module';
import { DirectivesModule } from '../shared/modules/directives.module';
import { SelectMobileDialogComponent } from './header/select-mobile-dialog/select-mobile-dialog.component';
import { EodReportComponent } from './header/eod-report/eod-report.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { AddComponentSupplyComponent } from './header/add-component-supply/add-component-supply.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ConfigureEodComponent } from './header/eod-report/configure-eod/configure-eod.component';
import { RejectedRequestComponent } from './header/rejected-request/rejected-request.component';
import { ManufacturerOrderPopupComponent } from './header/manufacturer-order-popup/manufacturer-order-popup.component';
import { ApplicationAlertComponent } from './header/application-alert/application-alert.component';
import { SelectAddressDialogComponent } from './header/select-address-dialog/select-address-dialog.component';
import { RejectNotificationComponent } from './header/reject-notification/reject-notification.component';
import { EntityVerificationFormComponent } from './navigation/entity-verification-form/entity-verification-form.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EntityVerificationPdfComponent } from './navigation/entity-verification-pdf/entity-verification-pdf.component';
import { EntityConfirmationFormComponent } from './navigation/entity-confirmation-form/entity-confirmation-form.component';




@NgModule({
  imports: [CommonModule, BsDatepickerModule, RouterModule, FormsModule,
     ReactiveFormsModule, DirectivesModule, MaterialModule, NgSelectModule,FontAwesomeModule, NgxMaskDirective,
      NgxMaskPipe,
      AccordionModule.forRoot()],
  declarations: [
    SelectMobileDialogComponent,
    EodReportComponent,
    ConfigureEodComponent,
    AddComponentSupplyComponent,
    RejectedRequestComponent,
    ManufacturerOrderPopupComponent,
    ApplicationAlertComponent,
    SelectAddressDialogComponent,
    RejectNotificationComponent,
    EntityVerificationFormComponent,
    EntityVerificationPdfComponent,
    EntityConfirmationFormComponent
  ],
  exports: [NgSelectModule,MatDialogModule],
  providers: [provideNgxMask()]

})
export class AppCommonModule { }
